/**
 * @file       Notification model for managing messages between users
 * @version    2.0.0
 * @author     Mehran Majidi
 * @copyright  Copyright (c) 2018, MindShare HDV LLC.  All rights reserved.
 *             Property of MindShare HDV LLC.  This file cannot be used or 
 *             altered in anyway without expressed written permission from 
 *             MindShare HDV LLC.
 */
import { NotificationType } from './NotificationType';

class Notification 
{
    constructor
    (
        public id: number,
        public type: NotificationType,
        public title: string,
        public message: string,
        public timeout: number,
    ) { }
}

export { Notification };